import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import CarnitasDonLupePage from '../pages/dining/carnitas-don-lupe/page';
import SakuraSushiHousePage from '../pages/dining/sakura-sushi-house/page';
import BorderBurgerCoPage from '../pages/dining/border-burger-co/page';
import VerdeCocinaPage from '../pages/dining/verde-cocina/page';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ExplorePage = lazy(() => import('../pages/explore/page'));
const DiningPage = lazy(() => import('../pages/dining/page'));
const MedicalTourismPage = lazy(() => import('../pages/medical-tourism/page'));
const BorderCrossingsPage = lazy(() => import('../pages/border-crossings/page'));
const AttractionsPage = lazy(() => import('../pages/attractions/page'));
const HistoryPage = lazy(() => import('../pages/history/page'));
const AboutJuarezPage = lazy(() => import('../pages/about-juarez/page'));
const Cerveceria19Page = lazy(() => import('../pages/dining/cerveceria19/page'));
const TaqueriaElPaisaPage = lazy(() => import('../pages/dining/taqueria-el-paisa/page'));
const LaCabanaPage = lazy(() => import('../pages/dining/la-cabana/page'));
const ElTragaderoPage = lazy(() => import('../pages/dining/el-tragadero/page'));
const MariscosElGueroPage = lazy(() => import('../pages/dining/mariscos-el-guero/page'));
const TavolaItalianBistroPage = lazy(() => import('../pages/dining/tavola-italian-bistro/page'));
const TacosElPrimoPage = lazy(() => import('../pages/dining/tacos-el-primo/page'));
const LaFogataPage = lazy(() => import('../pages/dining/la-fogata/page'));
const MartinoRestaurantPage = lazy(() => import('../pages/dining/martino-restaurant/page'));
const BurritosChrisostomoPage = lazy(() => import('../pages/dining/burritos-chrisostomo/page'));
const KentuckyClubPage = lazy(() => import('../pages/dining/kentucky-club/page'));
const DentalExcellenceJuarezPage = lazy(() => import('../pages/medical-tourism/dental-excellence-juarez/page'));
const GrupoMedicoJuarezPage = lazy(() => import('../pages/medical-tourism/grupo-medico-juarez/page'));
const DrMartinezCosmeticSurgeryPage = lazy(() => import('../pages/medical-tourism/dr-martinez-cosmetic-surgery/page'));
const CathedralOfCiudadJuarezPage = lazy(() => import('../pages/attractions/cathedral-of-ciudad-juarez/page'));
const MuseoDeLaRevolucionPage = lazy(() => import('../pages/attractions/museo-de-la-revolucion/page'));
const ParqueCentralHermanosEscobarPage = lazy(() => import('../pages/attractions/parque-central-hermanos-escobar/page'));
const LocalShoppingPage = lazy(() => import('../pages/local-shopping/page'));
const LocalServicesPage = lazy(() => import('../pages/local-services/page'));
const TouristTransportationPage = lazy(() => import('../pages/tourist-transportation/page'));
const ViralNewsPage = lazy(() => import('../pages/viral-news/page'));
const SentinelTowerPage = lazy(() => import('../pages/viral-news/sentinel-tower-surveillance-controversy/page'));
const TradeRemediationPage = lazy(() => import('../pages/viral-news/us-mexico-trade-remediation-2026/page'));
const TrumpFrictionPage = lazy(() => import('../pages/viral-news/trump-administration-mexico-friction-juarez-impact/page'));
const ColdWeatherTipsPage = lazy(() => import('../pages/viral-news/cold-weather-bridge-crossing-tips/page'));
const BorderWallPage = lazy(() => import('../pages/viral-news/juarez-el-paso-border-wall-february-2026/page'));
const BiometricsPage = lazy(() => import('../pages/viral-news/border-crossing-biometrics-cell-phone-inspections/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
import PesoDollarExchangePage from '../pages/peso-dollar-exchange/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/juarez-mexico-city-guide',
    element: <ExplorePage />,
  },
  {
    path: '/learn-about-juarez-mexico',
    element: <AboutJuarezPage />,
  },
  {
    path: '/learn-about-juarez-mexico/history-of-juarez-chihuahua-mexico',
    element: <HistoryPage />,
  },
  {
    path: '/places-to-eat',
    element: <DiningPage />,
  },
  {
    path: '/medical-tourism-mexico',
    element: <MedicalTourismPage />,
  },
  {
    path: '/places-to-eat/cerveceria19',
    element: <Cerveceria19Page />,
  },
  {
    path: '/places-to-eat/taqueria-el-paisa',
    element: <TaqueriaElPaisaPage />,
  },
  {
    path: '/places-to-eat/la-cabana',
    element: <LaCabanaPage />,
  },
  {
    path: '/places-to-eat/carnitas-don-lupe',
    element: <CarnitasDonLupePage />,
  },
  {
    path: '/places-to-eat/sakura-sushi-house',
    element: <SakuraSushiHousePage />,
  },
  {
    path: '/places-to-eat/border-burger-co',
    element: <BorderBurgerCoPage />,
  },
  {
    path: '/places-to-eat/verde-cocina',
    element: <VerdeCocinaPage />,
  },
  {
    path: '/places-to-eat/el-tragadero',
    element: <ElTragaderoPage />,
  },
  {
    path: '/places-to-eat/mariscos-el-guero',
    element: <MariscosElGueroPage />,
  },
  {
    path: '/places-to-eat/tavola-italian-bistro',
    element: <TavolaItalianBistroPage />,
  },
  {
    path: '/places-to-eat/tacos-el-primo',
    element: <TacosElPrimoPage />,
  },
  {
    path: '/places-to-eat/la-fogata',
    element: <LaFogataPage />,
  },
  {
    path: '/places-to-eat/martino-restaurant',
    element: <MartinoRestaurantPage />,
  },
  {
    path: '/places-to-eat/burritos-chrisostomo',
    element: <BurritosChrisostomoPage />,
  },
  {
    path: '/places-to-eat/kentucky-club',
    element: <KentuckyClubPage />,
  },
  {
    path: '/medical-tourism-mexico/dental-excellence-juarez',
    element: <DentalExcellenceJuarezPage />,
  },
  {
    path: '/medical-tourism-mexico/grupo-medico-juarez',
    element: <GrupoMedicoJuarezPage />,
  },
  {
    path: '/medical-tourism-mexico/dr-martinez-cosmetic-surgery',
    element: <DrMartinezCosmeticSurgeryPage />,
  },
  {
    path: '/border-crossing-wait-times',
    element: <BorderCrossingsPage />,
  },
  {
    path: '/attractions',
    element: <AttractionsPage />,
  },
  {
    path: '/attractions/cathedral-of-ciudad-juarez',
    element: <CathedralOfCiudadJuarezPage />,
  },
  {
    path: '/attractions/museo-de-la-revolucion',
    element: <MuseoDeLaRevolucionPage />,
  },
  {
    path: '/attractions/parque-central-hermanos-escobar',
    element: <ParqueCentralHermanosEscobarPage />,
  },
  {
    path: '/local-shopping',
    element: <LocalShoppingPage />,
  },
  {
    path: '/local-services',
    element: <LocalServicesPage />,
  },
  {
    path: '/tourist-transportation',
    element: <TouristTransportationPage />,
  },
  {
    path: '/peso-dollar-exchange-rate',
    element: <PesoDollarExchangePage />
  },
  {
    path: '/viral-news-juarez-mx',
    element: <ViralNewsPage />
  },
  {
    path: '/viral-news-juarez-mx/sentinel-tower-surveillance-controversy',
    element: <SentinelTowerPage />
  },
  {
    path: '/viral-news-juarez-mx/us-mexico-trade-remediation-2026',
    element: <TradeRemediationPage />
  },
  {
    path: '/viral-news-juarez-mx/trump-administration-mexico-friction-juarez-impact',
    element: <TrumpFrictionPage />
  },
  {
    path: '/viral-news-juarez-mx/cold-weather-bridge-crossing-tips',
    element: <ColdWeatherTipsPage />
  },
  {
    path: '/viral-news-juarez-mx/juarez-el-paso-border-wall-february-2026',
    element: <BorderWallPage />
  },
  {
    path: '/viral-news-juarez-mx/border-crossing-biometrics-cell-phone-inspections',
    element: <BiometricsPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
